// Will be replaced during production builds - see package.sh
export const BuildVersion = '0.20260320.1095832';
